import type {
  ArchibaldHandoffPort,
  HorizonCatalogPort,
  MealSuggestionPort,
  RecipeReturnVerifierPort,
} from './contracts';
import type { MealSuggestion, MealTemplate } from '../domain/meals';
import { suggestMeals } from '../domain/meals';
import type { FoodContainer, HorizonRuleSnapshot, IsoDate } from '../domain/model';

export class StaticHorizonCatalog implements HorizonCatalogPort {
  constructor(private readonly rules: HorizonRuleSnapshot[]) {}

  list(): HorizonRuleSnapshot[] {
    return structuredClone(this.rules);
  }

  find(id: string): HorizonRuleSnapshot | null {
    const rule = this.rules.find((candidate) => candidate.id === id);
    return rule == null ? null : structuredClone(rule);
  }
}

export class DeterministicMealSuggestionAdapter implements MealSuggestionPort {
  suggest(
    containers: FoodContainer[],
    templates: MealTemplate[],
    exclusions: string[],
    today: IsoDate,
  ): MealSuggestion[] {
    return suggestMeals(containers, templates, exclusions, today);
  }
}

/** Aucun secret HMAC ni endpoint central n’est embarqué dans la PWA. */
export class UnavailableRecipeReturnVerifier implements RecipeReturnVerifierPort {
  readonly available = false;

  verifyOnce() {
    return Promise.resolve({ state: 'unavailable' as const });
  }
}

/** Aucun payload réel ne quitte l’app tant que le gateway DOHM n’est pas configuré. */
export class UnavailableArchibaldHandoff implements ArchibaldHandoffPort {
  readonly available = false;

  status() {
    return Promise.resolve({ state: 'disconnected' as const });
  }

  connect() {
    return Promise.resolve({
      state: 'fallback' as const,
      access: 'unavailable' as const,
      fallbackUrl: null,
    });
  }

  disconnect() {
    return Promise.resolve();
  }

  prepare() {
    return Promise.resolve({
      state: 'fallback' as const,
      access: 'unavailable' as const,
      fallbackUrl: null,
    });
  }

  completeKeyExchange() {
    return Promise.resolve({ state: 'unavailable' as const });
  }

  retrieveReceipt() {
    return Promise.resolve({ state: 'none' as const, intentId: null });
  }

  verifyReceipt() {
    return Promise.resolve({
      state: 'unavailable' as const,
      intentId: null,
    });
  }
}
